import { Injectable } from '@angular/core';
import {
  AssistantApiModel,
  AssistantDocumentDetails,
  AssistantFeedbackData,
  AssistantFeedbackParams,
  AssistantFiltersData,
  AssistantSearchData,
  AssistantSuggestData,
} from '@vi-iot/client/apis/assistant/assistant.api-model';
import {
  assistantDeFiltersMockData,
  assistantEnFiltersMockData,
} from '@vi-iot/client/apis/assistant/mocks/assistantFilters.mock';
import {
  assistantFeedbackMockedData,
  assistantSearchMockedData,
} from '@vi-iot/client/apis/assistant/mocks/search.mock';
import { suggestionsMockedData } from '@vi-iot/client/apis/assistant/mocks/suggestions.mock';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import {
  AppServiceType,
  AssistantFilterPayload,
  AssistantSupportedLanguages,
} from '../../../../app/@store/assistant';

@Injectable({ providedIn: 'root' })
export class AssistantMockApi implements AssistantApiModel {
  getFilters(
    _app: AppServiceType,
    _searchText: string = null,
    _filtersPayload: AssistantFilterPayload = null,
    language: string = null
  ): Observable<AssistantFiltersData> {
    switch (language) {
      case AssistantSupportedLanguages.en:
        return of({
          filters: assistantEnFiltersMockData,
        });
      case AssistantSupportedLanguages.de:
        return of({
          filters: assistantDeFiltersMockData,
        });
      default:
        return of({
          filters: assistantEnFiltersMockData,
        });
    }
  }

  getSuggestion(query: string): Observable<AssistantSuggestData[]> {
    const filteredData = suggestionsMockedData.filter(
      (data) => data.query.toLowerCase() === query.toLowerCase()
    );
    return of(filteredData);
  }

  searchDocuments(
    text: string,
    _app: AppServiceType,
    _filtersPayload: AssistantFilterPayload,
    _language: string = null,
    _limit: number = 9,
    _offset: number = 0
  ): Observable<AssistantSearchData> {
    if (text.toLowerCase() === 'vitocall') {
      return of({
        results: assistantSearchMockedData.slice(0, 10),
        count: 10,
        totalCount: 10,
        searchInsightId: 'someID',
      });
    }

    if (text.toLowerCase() === 'vitocall 200-s') {
      return of({
        results: assistantSearchMockedData.slice(10, 20),
        count: 10,
        totalCount: 10,
        searchInsightId: 'someID',
      });
    }

    if (text.toLowerCase() === 'vitoair') {
      return of({
        results: assistantSearchMockedData.slice(20, 30),
        count: 10,
        totalCount: 10,
        searchInsightId: 'someID',
      });
    }

    return of({
      results: [],
      count: 0,
      totalCount: 0,
      searchInsightId: 'someID',
    });
  }

  getDocumentContent(_documentID: string): Observable<string> {
    return of(null);
  }

  getDocumentDetails(_documentId: string): Observable<AssistantDocumentDetails> {
    return of(null);
  }

  getAssistantFeedbackData(
    _search = null,
    _startDate = null,
    _endDate = null,
    _sortOrder = null,
    _limit = null,
    _offset = null
  ): Observable<AssistantFeedbackData> {
    return of({ feedbacks: assistantFeedbackMockedData, limit: 10, offset: 0, total: 10 }).pipe(
      delay(3000)
    );
  }

  rateDocument(_documentId: string, _params: AssistantFeedbackParams): Observable<void> {
    return of();
  }

  getResource(_objectId: string, _resourceName: string): Observable<Blob> {
    return of(null);
  }
}
